import { styled } from '@mui/material/styles';

export const Container = styled('div')(({ theme }) => ({
  padding: '20px',
  borderRadius: 9,
  backgroundColor: 'white',
  border: `2px solid ${theme.palette.background.paper}`,
  margin: theme.spacing(4),
}));

export const Logo = styled('div')(({ theme }) => ({
  marginTop: theme.spacing(5),
  marginBottom: theme.spacing(4),
}));

export const LogoBackground = styled('div')(() => ({
  width: 'auto',
  height: 'auto',
  position: 'fixed',
  marginTop: '-550px',
  opacity: '0.5',
}));

export const Line = styled('div')(({ theme }) => ({
  marginBottom: theme.spacing(2),
  backgroundColor: '#5e6977',
  height: '7px',
  width: '60%',
}));

export const ErrorCode = styled('div')(() => ({
  color: '#5e6977',
  fontFamily: 'Lato',
  fontWeight: 700,
}));

export const ErrorText = styled('div')(() => ({
  color: '#5e6977',
  fontFamily: 'Lato',
  width: '70%',
  marginBottom: '20px',
}));

export const StyledButtonWrapper = styled('div')(() => ({
  justifyContent: 'center',
  marginTop: '18px',
  marginBottom: '18px',
  width: '45%',
}));
